// tslint:disable:no-any

import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import Title from '../components/Title';
import { loadDiveData } from '../actions/diveActions';
import Mixtures from '../components/DiveMixtures';
import EventsTable from '../components/DiveEvents';
import DiveComments from '../components/DiveComments';
import DiveShareModal from '../components/DiveShareModal';
import DiveCharts from '../components/DiveCharts';
import DiveDataCards from '../components/DiveDataCards';
import DiveModeInformation from '../components/DiveModeInformation';
import { DisplayDateTime } from '../components/Display';
import Loader from '../components/Loader';
import ErrorPage from '../components/ErrorPage';
import DiveRemoveModal from '../components/DiveRemoveModal';
import DiveDescription from '../components/DiveDescription';
import { DiveService } from '../services/DiveService';
import Dt from 'react-document-title';
import { NavigationStore } from './Navigation/NavigationStore';

export interface IDiveProps {
    match: any;
    loadDiveData: (diveId: any) => void;
    dive: any;
}

interface IDiveState {
    shared: boolean;
    dive: any;
    shareModal: boolean;
    shareTokenId: any;
    removeId: any;
    redirectToDashboard: boolean;
}

class Dive extends React.Component<IDiveProps, IDiveState> {
    constructor(props: IDiveProps) {
        super(props);
        this.state = {
            shared: false,
            dive: null,
            shareModal: false,
            // share token
            shareTokenId: null,
            // ponor ke smazani
            removeId: null,
            // redirect na dashboard
            redirectToDashboard: false
        };
    }

    componentWillReceiveProps(nextProps: IDiveProps) {
        this.setState(
            {
                dive: nextProps.dive
            },
            () => {
                if (
                    this.state.dive &&
                    this.state.dive.diveAndMixes &&
                    this.state.dive.diveAndMixes.dive &&
                    this.state.dive.diveAndMixes.dive.serial
                ) {
                    /*Navigation._setActive(
                        'dives',
                        `Dive #${
                            this.state.dive.diveAndMixes.dive.serial
                        } detail`
                    );*/
                }
            }
        );
    }

    componentDidMount() {
        NavigationStore.getInstance().setActive('dives');
        this.props.loadDiveData(this.props.match.params.diveId);
        window.scrollTo(0, 0);
    }

    refreshDiveData() {
        this.props.loadDiveData(this.props.match.params.diveId);
    }

    async onShareDive() {
        const result = await DiveService.getInstance().getShareDiveTokenByDiveId(
            this.props.match.params.diveId
        );

        if (result == undefined) {
            return;
        }
        if (
            result.diveId == this.props.match.params.diveId &&
            result.tokenId != undefined
        ) {
            this.setState({
                shareModal: true,
                shareTokenId: result.tokenId
            });
        }
    }

    hideShareDiveModal() {
        this.setState({
            shareModal: false,
            shareTokenId: null
        });
    }

    scrollToComments() {
        window.scrollTo(
            0,
            document.body.scrollTop +
                ReactDOM.findDOMNode(this.refs.comments).getBoundingClientRect()
                    .top
        );
    }

    onClickRemoveDive(e: any, diveId: any) {
        this.setState({
            removeId: diveId
        });
    }

    hideRemoveModal() {
        this.setState({
            removeId: null
        });
    }

    async handleRemoveDive() {
        /*let url = 'dives';
        if (this.state.shared === true) {
            url = 'sharedDives';
        }*/ // TODO: odstranit shared, if shared

        const result = await DiveService.getInstance().removeDiveByDiveId(
            this.props.match.params.diveId
        );

        if (result != undefined) {
            if (result.status === 200) {
                this.setState({
                    removeId: null,
                    redirectToDashboard: true
                });
            }
        }
    }

    getTitle() {
        if (
            this.state.dive &&
            this.state.dive.diveAndMixes &&
            this.state.dive.diveAndMixes.dive &&
            this.state.dive.diveAndMixes.dive.serial
        ) {
            return `WetNotes | Dive #${
                this.state.dive.diveAndMixes.dive.serial
            } detail`;
        }

        return 'WetNotes | Dive detail';
    }

    render() {
        let dive = this.state.dive;

        if (dive === undefined || dive === null) {
            return <Loader />;
        }

        if (
            !dive ||
            !dive.diveAndMixes ||
            !dive.diveAndMixes.dive ||
            dive.errorText !== undefined
        ) {
            return <ErrorPage />;
        }

        return (
            <Dt title={this.getTitle()}>
                <div className="dive">
                    <Title
                        heading={`Dive #${dive.diveAndMixes.dive.serial}`}
                        breadcrumbs={[
                            { caption: 'My Dives', to: '/app/dives' },
                            {
                                caption: `Dive #${
                                    dive.diveAndMixes.dive.serial
                                }`,
                                to: `/app/dives/${dive.diveAndMixes.dive.id}`
                            }
                        ]}
                    />

                    <DiveRemoveModal
                        display={this.state.removeId !== null}
                        hideModal={() => this.hideRemoveModal()}
                        modalConfirm={() => this.handleRemoveDive()}
                    />

                    {this.state.redirectToDashboard && <Redirect to="/app" />}

                    <div className="wrapper">
                        <div className="dive__chart">
                            {dive.diveAndMixes !== undefined && (
                                <div className="dive__chart__header cf">
                                    <h3>
                                        Dive #{dive.diveAndMixes.dive.serial},&nbsp;
                                        {dive.diveAndMixes.dive.location !==
                                            null &&
                                        dive.diveAndMixes.dive.location !== ''
                                            ? dive.diveAndMixes.dive.location +
                                              ', '
                                            : ''}
                                        <DisplayDateTime
                                            data={
                                                dive.diveAndMixes.dive.startDate
                                            }
                                        />
                                    </h3>
                                    <div>
                                        <span
                                            className="dive__chart__header__icon--comment"
                                            onClick={() =>
                                                this.scrollToComments()
                                            }
                                        >
                                            Comments ({dive.comments.length})
                                        </span>
                                        <span
                                            className="dive__chart__header__icon--share"
                                            onClick={e => this.onShareDive()}
                                        >
                                            Share
                                        </span>
                                        <Link
                                            to={`/app/dive/edit/${
                                                dive.diveAndMixes.dive.id
                                            }`}
                                            className="dive__chart__header__icon--pencil"
                                        >
                                            Edit
                                        </Link>
                                        <span
                                            className="dive__chart__header__icon--trash"
                                            onClick={e =>
                                                this.onClickRemoveDive(
                                                    e,
                                                    undefined
                                                )
                                            }
                                        >
                                            Delete
                                        </span>
                                    </div>
                                </div>
                            )}

                            {this.state.dive.diveData !== undefined && (
                                <DiveCharts
                                    diveData={
                                        this.state.dive.diveData.graphData
                                    }
                                    diveEvents={this.state.dive.diveData.events}
                                />
                            )}
                        </div>

                        <DiveDataCards dive={dive} shared={false} />

                        <section>
                            {dive.diveAndMixes !== undefined && (
                                <DiveModeInformation dive={dive} />
                            )}

                            {dive.diveAndMixes !== undefined && (
                                <DiveDescription dive={dive} />
                            )}

                            {dive.diveAndMixes !== undefined && (
                                <Mixtures data={dive.diveAndMixes.mixes} />
                            )}

                            {dive.diveData !== undefined && (
                                <EventsTable data={dive.diveData.events} />
                            )}
                        </section>

                        {dive.diveData !== undefined && (
                            <DiveComments
                                // tslint:disable-next-line:jsx-no-string-ref
                                ref="comments"
                                dive={dive}
                                // onRefreshDiveData={() => this.refreshDiveData()}
                            />
                        )}
                    </div>

                    <DiveShareModal
                        display={this.state.shareModal}
                        shareTokenId={this.state.shareTokenId}
                        hideModal={() => this.hideShareDiveModal()}
                    />
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dive: state.dive || {}
});

const mapDispatchToProps = (dispatch: any) => ({
    loadDiveData: (diveId: any) => dispatch(loadDiveData(diveId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Dive as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dive.tsx